module.exports = __webpack_public_path__ + "static/media/pickle_squares.583fcd66.png";